import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Standardized admin status pills. One wording/colour treatment for every
 * entity status across the whole administration backend.
 */
const STATUS_MAP = {
  // Projects
  draft: { label: 'Draft', tone: 'grey' },
  published: { label: 'Published', tone: 'green' },
  funding: { label: 'Funding', tone: 'blue' },
  funded: { label: 'Funded', tone: 'blue' },
  open: { label: 'Open', tone: 'green' },
  active: { label: 'Active', tone: 'green' },
  completed: { label: 'Completed', tone: 'blue' },
  archived: { label: 'Archived', tone: 'grey' },
  closed: { label: 'Closed', tone: 'grey' },
  // Subscriptions
  pending: { label: 'Pending', tone: 'amber' },
  approved: { label: 'Approved', tone: 'green' },
  allocated: { label: 'Allocated', tone: 'green' },
  paid: { label: 'Paid', tone: 'green' },
  cancelled: { label: 'Cancelled', tone: 'grey' },
  rejected: { label: 'Rejected', tone: 'red' },
  // KYC
  none: { label: 'Not started', tone: 'grey' },
  basic: { label: 'Pending review', tone: 'amber' },
  standard: { label: 'Verified', tone: 'green' },
  enhanced: { label: 'Verified+', tone: 'green' },
  // Instruments
  frozen: { label: 'Frozen', tone: 'blue' },
  retired: { label: 'Retired', tone: 'grey' },
  // Generic
  missing: { label: 'Missing', tone: 'red' },
  overdue: { label: 'Overdue', tone: 'red' },
};

const TONES = {
  grey: 'bg-slate-100 text-slate-600',
  green: 'bg-emerald-50 text-emerald-700',
  blue: 'bg-blue-50 text-blue-700',
  amber: 'bg-amber-50 text-amber-700',
  red: 'bg-red-50 text-red-700',
};

const DOTS = {
  grey: 'bg-slate-400',
  green: 'bg-emerald-500',
  blue: 'bg-blue-500',
  amber: 'bg-amber-500',
  red: 'bg-red-500',
};

export const StatusPill = ({ status, label, tone, dot = true, className = '', testId }) => {
  const key = (status || '').toString().toLowerCase();
  const mapped = STATUS_MAP[key] || { label: label || status || '—', tone: tone || 'grey' };
  const finalTone = tone || mapped.tone;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        TONES[finalTone],
        className
      )}
      data-testid={testId}
    >
      {dot && <span className={cn('w-1.5 h-1.5 rounded-full', DOTS[finalTone])} />}
      {label || mapped.label}
    </span>
  );
};

export default StatusPill;
